import z from 'zod'

export const zColor = z.string().regex(/^#[0-9A-Fa-f]{6}$/)
